import { majorArcana } from './majorArcana';
import { wands } from './wands';
import { cups } from './cups';
import { swords } from './swords';
import { pentacles } from './pentacles';

// 完整 78 張塔羅牌庫整合
export const tarotDeck = {
  cards: [
    ...majorArcana, // 22 張大阿爾克那
    ...wands,       // 14 張權杖
    ...cups,        // 14 張聖杯
    ...swords,      // 14 張寶劍
    ...pentacles    // 14 張星幣
  ],
  // 使用 data URI 內嵌的深色神秘塔羅牌背（完全不依賴外部圖片）
  cardBackImg: `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 300 500'%3E%3Cdefs%3E%3ClinearGradient id='bg' x1='0%25' y1='0%25' x2='0%25' y2='100%25'%3E%3Cstop offset='0%25' style='stop-color:%231a0a2e;stop-opacity:1' /%3E%3Cstop offset='100%25' style='stop-color:%230a0505;stop-opacity:1' /%3E%3C/linearGradient%3E%3Cpattern id='grain' patternUnits='userSpaceOnUse' width='100' height='100'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' /%3E%3C/filter%3E%3Crect width='100' height='100' filter='url(%23noise)' opacity='0.03'/%3E%3C/pattern%3E%3C/defs%3E%3Crect width='300' height='500' fill='url(%23bg)'/%3E%3Crect width='300' height='500' fill='url(%23grain)'/%3E%3Crect x='10' y='10' width='280' height='480' fill='none' stroke='%23d4af37' stroke-width='2' opacity='0.4'/%3E%3Crect x='15' y='15' width='270' height='470' fill='none' stroke='%23d4af37' stroke-width='1' opacity='0.3'/%3E%3Ccircle cx='150' cy='250' r='80' fill='none' stroke='%23d4af37' stroke-width='1.5' opacity='0.25'/%3E%3Cpath d='M150 180 L160 240 L220 250 L160 260 L150 320 L140 260 L80 250 L140 240 Z' fill='%23d4af37' opacity='0.15'/%3E%3Ccircle cx='150' cy='250' r='25' fill='none' stroke='%23d4af37' stroke-width='2' opacity='0.3'/%3E%3Ctext x='150' y='440' text-anchor='middle' font-family='serif' font-size='12' fill='%23d4af37' opacity='0.5'%3ETAROT%3C/text%3E%3C/svg%3E`
};

/**
 * 隨機抽取一張塔羅牌
 * @returns {Object} 包含卡片資料與正逆位狀態
 */
export const drawRandomCard = () => {
  const randomIndex = Math.floor(Math.random() * tarotDeck.cards.length);
  const card = tarotDeck.cards[randomIndex];
  
  // 隨機決定正逆位 (50/50 機率)
  const isUpright = Math.random() >= 0.5;
  
  return {
    ...card,
    isUpright,
    currentMeaning: isUpright ? card.upright : card.reversed,
    statusText: isUpright ? '正位' : '逆位'
  };
};

/**
 * 抽取多張牌 (用於三張牌陣等進階功能)
 * @param {number} count - 抽取數量
 * @returns {Array} 抽取的牌陣
 */
export const drawMultipleCards = (count = 3) => {
  const drawn = [];
  const usedIndices = new Set();
  
  while (drawn.length < count && usedIndices.size < tarotDeck.cards.length) {
    const randomIndex = Math.floor(Math.random() * tarotDeck.cards.length);
    if (!usedIndices.has(randomIndex)) {
      usedIndices.add(randomIndex);
      const card = tarotDeck.cards[randomIndex];
      const isUpright = Math.random() >= 0.5;
      
      drawn.push({
        ...card,
        isUpright,
        currentMeaning: isUpright ? card.upright : card.reversed,
        statusText: isUpright ? '正位' : '逆位'
      });
    }
  }
  
  return drawn;
};